module.exports = __webpack_public_path__ + "static/media/search.28754c4e.svg";